import React from 'react';
import styled from 'styled-components';

import MainLogo from '@components/navigation/MainLogo';
import { useRecoilValue } from 'recoil';
import {
  menuFixedState,
  menuHeightState,
  menuTypeState,
  topNavSideSeparatedState,
} from '@atom/setting/homepageSet';
import { MENU_DESIGN_TYPE } from '@typings/menu/menuType';
import NotificationBtn from '@template/Notifications/NotificationBtn';
import { masterSet } from '@masterSetting/masterSet/masterSetting';
import MusicButton from '@template/MusicPlayer/MusicBtn';
import LoginUserSec from '../common/LoginUserSec';
import NavList from '../common/NavList';
import ChatBtn from '@pages/Chat/ChatBtn';

const Header = styled.header<{
  fixed?: boolean;
}>`
  position: ${({ fixed }) => (fixed ? 'fixed' : 'static')};
  left: 0;
  top: 0px;
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  z-index: 1;
  background: center / cover no-repeat;

  ${({ fixed }) =>
    fixed &&
    `
    padding-top: env(safe-area-inset-top);
    height: calc(80px + env(safe-area-inset-top));
  `}
`;

const LogoSec = styled.div`
  display: flex;
  align-items: center;
`;

const SideWrap = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
`;

const BtnWrap = styled.div`
  display: flex;
  align-items: center;
`;

// 사이드 분리 OFF 시 최상단에 고정되는 바
const TopSideBar = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 16px;
  padding-top: calc(4px + env(safe-area-inset-top));
`;

function TopNav() {
  const menuType = useRecoilValue(menuTypeState);
  const menuFixed = useRecoilValue(menuFixedState);
  const menuHeight = useRecoilValue(menuHeightState);
  const topNavSideSeparated = useRecoilValue(topNavSideSeparatedState);

  const sideContent = (
    <SideWrap>
      <BtnWrap>
        <MusicButton color="var(--menuTextColor)" />
        <NotificationBtn
          dropdownDir="topRight"
          color="var(--menuTextColor)"
        />
        {masterSet.chat && <ChatBtn color="var(--menuTextColor)" />}
      </BtnWrap>

      <LoginUserSec />
    </SideWrap>
  );

  return (
    <>
      {!topNavSideSeparated && (
        <TopSideBar>{sideContent}</TopSideBar>
      )}
      <Header
        style={{
          height: menuHeight,
          backgroundImage:
            menuType === MENU_DESIGN_TYPE.NONE ||
              menuType === MENU_DESIGN_TYPE.COLOR
              ? ''
              : 'var(--menuImgURL)',
          backgroundColor:
            menuType === MENU_DESIGN_TYPE.COLOR
              ? 'var(--menuBackgroundColor)'
              : '',
          backdropFilter: menuType === MENU_DESIGN_TYPE.NONE ? '' : 'blur(12px)',
        }}
        fixed={menuFixed}
      >
        <LogoSec>
          <MainLogo />
        </LogoSec>
        <NavList tooltipDir="bottom" />
        {topNavSideSeparated && sideContent}
      </Header>
    </>
  );
}

export default TopNav;
